import React from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import LoginHeader from '../../components/atoms/LoginHeader';
import FooterMobile from '../../components/atoms/FooterMobile';
import GradientButton from '../../components/atoms/GradientButton';

import './styles.scss';

const CreatedAccountView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();

        history.push('/login');
    }

    return (
        <div className="created-account-container">
            <LoginHeader></LoginHeader>

            <div className="created-account-content">
                <form className="created-account-form" onSubmit={handleSubmit}>
                    <h1 className="created-account-title">Tu cuenta ha sido creada</h1>
                    <h2 className="created-account-subtitle">Enviamos un e-mail para confirmar el alta de usuario a tu casilla de correo.
                    <br></br><br></br>Si no lo recibiste, revisá la carpeta de correo no deseado.</h2>
                    <div className="created-account-button">
                        <GradientButton legend={'INGRESAR'} disabled={submitted}
                            handleClick={handleSubmit} type={'submit'} />
                    </div>
                </form>
            </div>
            {isMobile && <FooterMobile></FooterMobile>}
        </div>
    );
}

export default withTranslation()(CreatedAccountView);